import { IRuleSearch } from 'types/rules';
import { ISearchParams } from 'types/searchParams';

export const prepareSearchParams = (searchParams: IRuleSearch | undefined) => {
  if (!searchParams) {
    return {} as ISearchParams;
  }

  const params = {} as ISearchParams;

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      params[key as keyof ISearchParams] = String(value);
    }
  });

  return params;
};

export default prepareSearchParams;
